import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import QuestionAddEditPage from 'components/pages/QuestionAddEdit';
import pageTitles from 'utils/pageTitles';
import getRouteState from 'utils/getRouteState';
import { historyShape } from 'utils/shapes/router.shapes';

import { setTitle, setActiveMenuItem } from 'containers/store';

import {
  onSubmit,
  onCancel,
  loadPageData,
  closeAlertDialog,
} from './store';

class QuestionAddEdit extends React.Component {
  static propTypes = {
    closeAlertDialog: PropTypes.func.isRequired,
    history: historyShape.isRequired,
    intl: intlShape.isRequired,
    isLoadedPage: PropTypes.bool.isRequired,
    loadPageData: PropTypes.func.isRequired,
    setActiveMenuItem: PropTypes.func.isRequired,
    setTitle: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    questionId: PropTypes.number,
  };

  static defaultProps = {
    questionId: null,
  };

  componentDidMount() {
    this.props.setTitle(this.props.intl.formatMessage(pageTitles.questions));
    this.props.setActiveMenuItem('questions');
    const routeState = getRouteState(this.props.history);
    this.props.loadPageData(routeState);
  }

  render() {
    return this.props.isLoadedPage ? (
      <QuestionAddEditPage
        {...this.props}
      />
    ) : null;
  }
}

const mapDispatchToProps = {
  setTitle,
  onSubmit,
  onCancel,
  loadPageData,
  setActiveMenuItem,
  closeAlertDialog,
};

const mapStateToProps = (state) => ({
  ...state.QuestionAddEdit,
});

export default (
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(QuestionAddEdit)))
);
